import { Currency } from '../queries';

export const getCurrencyAmountAsFloat = (
  amount: number,
  decimal: number = 2,
) => {
  const factor = Math.pow(10, decimal);
  return amount / factor;
};

export const getFloatCurrencyAmountAsInteger = (
  amount: number,
  decimal: number = 2,
) => {
  const factor = Math.pow(10, decimal);
  return Math.round(amount * factor);
};

const convertToEuro = (amount: number, currency: Currency) => {
  if (currency.code === 'EUR') {
    return amount;
  }

  if (!currency.EURExchangeRate) {
    return undefined;
  }

  const floatAmount = getCurrencyAmountAsFloat(amount, currency.decimal);
  const eurFloatAmount = floatAmount / currency.EURExchangeRate;
  return getFloatCurrencyAmountAsInteger(eurFloatAmount, 2);
};

const convertEurToCurrency = (amount: number, currency: Currency) => {
  if (currency.code === 'EUR') {
    return amount;
  }

  if (!currency.EURExchangeRate) {
    return undefined;
  }

  const floatAmount = getCurrencyAmountAsFloat(amount, 2);
  const eurFloatAmount = floatAmount * currency.EURExchangeRate;
  return getFloatCurrencyAmountAsInteger(eurFloatAmount, currency.decimal);
};

export const convertToCurrency = (
  amount: number,
  fromCurrency: Currency,
  toCurrency: Currency,
) => {
  const eur = convertToEuro(amount, fromCurrency);
  if (!eur) {
    return undefined;
  }
  return convertEurToCurrency(eur, toCurrency);
};

export const roundDown = (
  amount: number,
  roundMinPercentReduce: number = 5,
) => {
  const minReduce = amount * (1 - roundMinPercentReduce / 100);
  let currentVal = amount;
  let nextVal = amount;
  let i = 0;
  do {
    currentVal = nextVal;
    if (i % 2 === 0) {
      const mul = Math.pow(10, i / 2);
      nextVal = Math.floor(currentVal / mul) * mul;
    } else {
      const mul = Math.pow(10, (i + 1) / 2);
      const halfRound = (Math.floor(currentVal / mul) + 0.5) * mul;
      if (halfRound < amount) {
        nextVal = halfRound;
      }
    }
    i++;
  } while (nextVal > minReduce);
  return currentVal;
};

export const getRoundedUpEuro = (amount: number, currencyInfo: Currency) => {
  if (currencyInfo.code === 'EUR') {
    return amount;
  }
  const exactEur = convertToEuro(amount, currencyInfo);
  if (exactEur === undefined) {
    return 0;
  }
  const maxIncrease = exactEur * (1 + 0.05);

  let currentVal = exactEur;
  let nextVal = exactEur;

  let i = 0;
  do {
    currentVal = nextVal;
    let rounded: number;
    if (i % 2 === 0) {
      const mul = Math.pow(10, i / 2);
      rounded = Math.ceil(currentVal / mul) * mul;
    } else {
      const mul = Math.pow(10, (i + 1) / 2);
      rounded = (Math.floor(currentVal / mul) + 0.5) * mul;
    }

    if (rounded < currentVal) {
      i++;
      continue;
    }
    nextVal = rounded;

    i++;
  } while (nextVal < maxIncrease);
  return currentVal;
};
